import { api } from "@ts/core/api";
import { popMessage } from "@ts/core/Popup";

export class LogTool {

    public static async view(): Promise<void> {

        const resp = await api<Array<{ timestamp: string, type: string, message: string }>>('logView');
        if (!resp) {
            popMessage('Tom logg');
            return;
        }

        const form = document.createElement('form');
        form.className = 'log';

        const table = document.createElement('table');
        form.appendChild(table);

        for (let i = 0; i < resp.length; i++) {
            const logLine = resp[i];
            const tr = document.createElement('tr');
            tr.innerHTML = `<td>${logLine.timestamp}</td><td>${logLine.type}</td><td>${logLine.message}</td>`;
            table.appendChild(tr);
        }

        form.appendChild(document.createElement('hr'));

        const btn = document.createElement('button');
        btn.innerText = 'OK';
        form.appendChild(btn);

        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            form.remove();
        });

        document.body.appendChild(form);

    }

    public static clear(): void {
        
        api<void>('logClear');
        popMessage('Loggen nollställd');
    }

}
